import { callApi } from './client';

export interface UserInfo {
  userId: number;
  fName: string;
  lName: string;
  fullName?: string;
  email?: string;
  legalFName?: string;
  legalLName?: string;
}

export interface LoginResult {
  authenticated: boolean;
}

export async function login(userName: string, password: string): Promise<LoginResult> {
  return callApi<LoginResult>('userApi', 'login', { userName, password });
}

export async function logout(): Promise<void> {
  await callApi('userApi', 'logout');
}

export async function getUserInfo(): Promise<UserInfo> {
  return callApi<UserInfo>('userApi', 'getUserInfo');
}

export async function sessionTimeLeft(): Promise<number> {
  return callApi<number>('userApi', 'sessionTimeLeft', { noRefreshLogin: 1 });
}
